import { render, staticRenderFns } from "./ContentProducersFilters.vue?vue&type=template&id=8be1a732"
import script from "./ContentProducersFilters.vue?vue&type=script&lang=js"
export * from "./ContentProducersFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports